import { useState, useContext } from 'react';
import _get from 'lodash/get';

import { ModalContext, AppContext } from 'commons-ui';
import { ISubmitForm60 } from '../types';

const useSubmitForm60 = (props: ISubmitForm60) => {
	const { turnForceUpdateOn, submitForm60Details } = props;

	const [showLoader, setShowLoader] = useState(false);
	const { setModalConfig } = useContext(ModalContext);
	const { showAlert } = useContext(AppContext);

	const handleFormSubmit = async (submittedData: any) => {
		const { year, documentNumber, documentType, fileName } = submittedData;
		try {
			setShowLoader(true);

			const formattedData: any = {
				year,
				documentNumber,
				documentType,
				fileName: `crm${fileName.split('/crm')[1]}`
			};
			await submitForm60Details(formattedData);
			setShowLoader(false);
			showAlert('Form60 submitted successfully.');
		} catch (error) {
			showAlert(_get(error, ['response', 'data', 'error'], 'Error in submitting form60'), { type: 'error' });
		} finally {
			setShowLoader(false);
			turnForceUpdateOn();
			setModalConfig({ isOpen: false });
		}
	};

	const handleFormCancel = () => {
		setModalConfig({ isOpen: false });
	};

	return {
		showLoader,
		setShowLoader,
		handleFormCancel,
		handleFormSubmit
	};
};

export default useSubmitForm60;
